import React, { useState } from 'react';
import ThreadV2 from './ThreadV2';
import DetailPanelV2 from './DetailPanelV2';
import GroupMembersPanel from './GroupMembersPanel';
import t from './theme';

// Embeds the v2 chat thread inside another page (e.g. the program/group "chat" tab).
// No conversation rail — the host page selects the conversation (sets it on ChatContext);
// we render the thread + composer, plus:
//   - GROUP: a persistent members sidebar (roster, presence, coach badge, stats)
//   - 1:1: an optional slide-in detail panel
const EmbeddedChatV2 = ({ conversation, program }) => {
  const [detailOpen, setDetailOpen] = useState(false);

  if (!conversation) return null;
  const isGroup = conversation.isGroup;

  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
        minWidth: 0,
        minHeight: 0,
        height: '100%',
        background: t.color.surface,
        border: `1px solid ${t.color.line}`,
        borderRadius: t.radius.lg,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ThreadV2
        conversation={conversation}
        onBack={() => {}}
        onToggleDetail={isGroup ? undefined : () => setDetailOpen((v) => !v)}
        detailOpen={detailOpen}
      />
      {isGroup ? (
        <GroupMembersPanel program={program} conversation={conversation} />
      ) : (
        detailOpen && (
          <DetailPanelV2 conversation={conversation} onClose={() => setDetailOpen(false)} />
        )
      )}
    </div>
  );
};

export default EmbeddedChatV2;
